const triggerBrowserDownload = (blobUrl: string, filename: string) => {
  const link = document.createElement("a")
  link.href = blobUrl
  link.download = filename
  link.style.display = "none"
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(blobUrl)
}

export const downloadFileFromUrl = async (
  url: string,
  filename: string,
  fetchOptions: { headers?: Record<string, string> } = {},
) => {
  const response = await fetch(url, fetchOptions)

  if (!response.ok) {
    throw new Error(`Failed to download file: ${response.status}`)
  }

  const blob = await response.blob()
  const blobUrl = URL.createObjectURL(blob)
  triggerBrowserDownload(blobUrl, filename)
}

export const downloadBlob = (content: string, filename: string, type: string = "application/octet-stream") => {
  const blob = new Blob([content], { type })
  const blobUrl = URL.createObjectURL(blob)
  triggerBrowserDownload(blobUrl, filename)
}
